<template>
  <a-drawer
:maskClosable="false"
width="35%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="onClose"
    :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="套餐名称" prop="packageName">
        <a-input v-model="form.packageName" placeholder="请输入(200元30G/年主套餐)" :maxLength="50" />
      </a-form-model-item>
      <!-- <a-form-model-item label="是否使用优惠券" prop="useCoupon">
        <a-radio-group v-model="form.useCoupon">
          <a-radio-button :value="1"> 是 </a-radio-button>
          <a-radio-button :value="0"> 否 </a-radio-button>
        </a-radio-group>
      </a-form-model-item> -->
      <a-form-model-item label="套餐类型" prop="packageType">
        <a-select
show-search
:allowClear="true"
v-model="form.packageType"
placeholder="请选择"
          option-filter-prop="children"
:filter-option="filterOption">
          <a-select-option v-for="d in packageType" :key="d.id">{{ d.name }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="套餐容量" prop="capacity">
        <a-input v-model="form.capacity"   oninput="value = value.replace(/[^\d.]/g, '').replace(/^\./, '').replace(/\.{2,}/g, '.').replace(/(?<=\.\d{2}).*/, '').replace(/(?<=\d+)\./, (m, i, str) => str.indexOf('.') === i ? m : '')" placeholder="请输入MB" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="单价" prop="unitPrice">
        <a-input
v-model="form.unitPrice"
placeholder="请输入(元/GB)"
:maxLength="20"
           oninput="value = value.replace(/[^\d.]/g, '').replace(/^\./, '').replace(/\.{2,}/g, '.').replace(/(?<=\.\d{2}).*/, '').replace(/(?<=\d+)\./, (m, i, str) => str.indexOf('.') === i ? m : '')"  />
      </a-form-model-item>
      <a-form-model-item label="套餐价格" prop="price">
        <a-input v-model="form.price" placeholder="请输入" :maxLength="20"   oninput="value = value.replace(/[^\d.]/g, '').replace(/^\./, '').replace(/\.{2,}/g, '.').replace(/(?<=\.\d{2}).*/, '').replace(/(?<=\d+)\./, (m, i, str) => str.indexOf('.') === i ? m : '')" />
      </a-form-model-item>
      <a-form-model-item label="有效期" prop="validDays">
        <a-input
v-model="form.validDays"
placeholder="请输入(天)"
:maxLength="20"
          oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item>
      <a-form-model-item label="套餐描述	" prop="description">
        <a-input v-model="form.description" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { mapGetters } from 'vuex'

import { getObj, addObj, putObj } from '@/api/VR/storagePackage'
import parameter from '@/mixins/parameter'
export default {
  name: 'CreateForm',
  components: {},
  mixins: [parameter],
  data() {
    return {
      submitLoading: false,
      showLoading: false,
      data: [],
      formTitle: '',
      // 表单参数
      form: {
        id: undefined,
        capacity: undefined,
        description: undefined,
        packageName: undefined,
        packageType: undefined,
        price: undefined,
        remark: undefined,
        unitPrice: undefined,
        validDays: undefined,
        sort: 99,
      },
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      rules: {
        capacity: [{ required: true, message: '请输入套餐容量(MB)', trigger: 'blur' }],
        packageName: [{ required: true, message: '请输入套餐名称', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        packageType: [{ required: true, message: '请选择套餐类型', trigger: 'blur' }],
        unitPrice: [{ required: true, message: '请输入单价(元/GB)', trigger: 'blur' }],
        price: [{ required: true, message: '请输入套餐价格', trigger: 'blur' }],
        validDays: [{ required: true, message: '请输入有效期(天)', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),
  },
  watch: {},
  methods: {
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() { },
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        capacity: undefined,
        description: undefined,
        packageName: undefined,
        packageType: undefined,
        price: undefined,
        remark: undefined,
        unitPrice: undefined,
        validDays: undefined,
        sort: 99,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '新增'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')

      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          }
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/.ant-form-item{
  margin-bottom: 0 !important;
}
</style>
